import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgView3D32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <defs>
        <path
          id="view-3D-32_svg__a"
          d="M7.142 13.737a.519.519 0 0 1-.293.673c-2.451.965-3.812 2.247-3.812 3.501 0 1.883 3.045 3.742 7.732 4.568.278.05.561.094.848.136l-1.41-1.94a.519.519 0 0 1 .043-.662l.07-.062a.519.519 0 0 1 .725.114l2.133 2.928a.519.519 0 0 1-.115.725l-2.937 2.128a.519.519 0 1 1-.608-.84l1.894-1.373c-.278-.04-.552-.085-.823-.133C5.454 22.595 2 20.487 2 17.911c0-1.793 1.665-3.362 4.47-4.466a.519.519 0 0 1 .672.292m18.435-.274C28.354 14.567 30 16.128 30 17.911c0 2.906-4.415 5.213-10.552 5.865a.519.519 0 1 1-.11-1.031c5.657-.601 9.625-2.675 9.625-4.834 0-1.246-1.344-2.52-3.769-3.484a.519.519 0 1 1 .383-.964M11.537 8c.553 0 1.05.104 1.487.313.438.21.781.49 1.03.844.25.353.374.755.374 1.205 0 .32-.064.608-.193.861a1.672 1.672 0 0 1-.566.633c-.25.168-.55.297-.904.385.378.065.707.201.988.41.281.209.498.466.65.771a2.2 2.2 0 0 1 .23 1c0 .498-.145.922-.434 1.271-.29.35-.665.617-1.127.802a4.002 4.002 0 0 1-1.5.277c-.49 0-.934-.079-1.331-.235a2.613 2.613 0 0 1-.988-.663 2.091 2.091 0 0 1-.512-.994l.602-.639c.024.233.129.47.313.711.185.241.44.44.766.597.325.156.704.235 1.138.235.37 0 .703-.062 1-.187.298-.125.535-.3.711-.524a1.23 1.23 0 0 0 .265-.783c0-.33-.108-.61-.325-.844-.217-.233-.524-.41-.922-.53-.397-.12-.87-.18-1.416-.18h-.41v-.904h.41c.74 0 1.33-.119 1.772-.356.441-.237.662-.592.662-1.066 0-.305-.082-.568-.247-.79a1.573 1.573 0 0 0-.65-.505 2.145 2.145 0 0 0-.862-.175c-.514 0-.95.114-1.307.343-.358.23-.609.496-.753.802l-.711-.735c.16-.282.385-.523.675-.723.289-.201.614-.356.976-.464A3.837 3.837 0 0 1 11.536 8zm7.486.108c.915 0 1.68.191 2.295.573a3.581 3.581 0 0 1 1.38 1.542c.305.647.458 1.364.458 2.15 0 .868-.17 1.623-.507 2.266a3.622 3.622 0 0 1-1.433 1.494c-.619.354-1.35.53-2.193.53h-2.964V8.108zm0 .964h-1.88V15.7h1.88c.658 0 1.213-.146 1.662-.44.45-.293.792-.69 1.025-1.192.233-.502.35-1.067.35-1.693 0-.643-.12-1.213-.356-1.711a2.726 2.726 0 0 0-1.03-1.169c-.45-.281-1-.422-1.651-.422z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="view-3D-32_svg__b" fill="#fff">
          <use xlinkHref="#view-3D-32_svg__a" />
        </mask>
        <use xlinkHref="#view-3D-32_svg__a" fill="#262729" fillRule="nonzero" />
        <g fill="#262729" mask="url(#view-3D-32_svg__b)">
          <path d="M0 0h32v32H0z" />
        </g>
      </g>
    </SvgIcon>
  );
};
const Memo = memo(SvgView3D32);
export default Memo;
